'use strict';

var styled = require('styled-components');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const rowStyles = styled.css `
  flex-direction: row;
  && > * {
    margin-right: ${({ space, theme }) => theme.space.component.x[space]};
  }
  && > *:last-child {
    margin-right: 0;
  }
`;
const rowReverseStyles = styled.css `
  flex-direction: row-reverse;
  /* stylelint-disable-next-line */
  && > * {
    margin-left: ${({ space, theme }) => theme.space.component.x[space]};
  }
  && > *:last-child {
    margin-left: 0;
  }
`;
const Row = styled__default.default.div `
  display: flex;
  flex-wrap: ${({ flexWrap = 'wrap' }) => flexWrap};
  justify-content: ${({ justifyContent = 'flex-start' }) => justifyContent};
  align-items: ${({ alignItems = 'center' }) => alignItems};
  ${({ reverse }) => (reverse ? rowReverseStyles : rowStyles)};
`;
Row.displayName = 'Flex.Row';

exports.Row = Row;
//# sourceMappingURL=Row.js.map
